import { ErrorPageDetailsTypes } from '../../../types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description:
    'Huy! Algo salió mal. Por favor vuelva a intentarlo dentro de un rato.',
  title: 'Error del sistema',
};
